import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Globe, ChevronDown } from "lucide-react";

const LANGS = [
  { code: "tr", label: "TR", full: "Türkçe" },
  { code: "en", label: "EN", full: "English" },
  { code: "de", label: "DE", full: "Deutsch" },
];

export default function LanguageSwitcher({ dark = true }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGS.find((l) => l.code === i18n.language?.slice(0, 2)) || LANGS[0];

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const change = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center gap-1 text-[11px] tracking-wider uppercase transition-colors ${dark ? "text-white/80 hover:text-gold" : "text-navy hover:text-gold"}`}
        data-testid="lang-switcher"
      >
        <Globe size={12} />
        <span>{current.label}</span>
        <ChevronDown size={10} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 bg-white rounded-md shadow-xl border border-gray-100 min-w-[120px] z-50">
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => change(l.code)}
              className={`w-full text-left px-3 py-2 text-xs hover:bg-softbg transition-colors ${l.code === current.code ? "text-gold font-medium" : "text-navy"}`}
              data-testid={`lang-${l.code}`}
            >
              {l.full}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
